import React, { useEffect } from 'react';
import AOS from 'aos';
import 'aos/dist/aos.css';

import Hero from './components/Hero';
import About from './components/About';
import Experience from './components/Experience';
import Projects from './components/Projects';
import Contact from './components/Contact';
import NavBar from './components/NavBar';

export default function App() {
    useEffect(() => {
        AOS.init({ duration: 700, once: true, offset: 80 });
    }, []);

    return (
        <>
            <NavBar />
            <Hero />
            <About />
            <Experience />
            <Projects />
            <Contact />
        </>
    );
}
